import { useLocation } from "react-router-dom";
import useWorkflowStore from "../../stores/useWorkflowStore";
import useEditorStore from "../../stores/useEditorStore";
import { SCAN_PROCESS_STEPS, MAIN_PROCESS_STEPS, PATHS } from "../../constants/flowConfig";
import { TOOLS_CONFIG } from "../../constants/tools";

// ELONGATION, TRIMLINE, ML_REDUCTION and FLARES scene handlers are now mounted by
// their migrated feature steps (features/{elongation,trimline,ml-reduction,flares}
// via *SceneHandlers), so they are no longer switched on here.
// Legacy ThicknessHandler intentionally not imported - the THICKNESS step now
// uses OutwardThicknessHandler (true outward Minkowski offset + outward
// extrude preview). The legacy module is left on disk for reference.
import MeasureHandler from "../../tools/measure/MeasureHandler";
import CircumferenceHandler from "../../tools/circumference/CircumferenceHandler";
import CircumferenceLinesHandler from "../../tools/circumferenceLines/CircumferenceLinesHandler";
// LOCKING_MECHANISM (SocketAlignHandler) and LOGO_PLACEMENT (LogoPlacementHandler)
// scene handlers are now mounted by their migrated feature steps
// (features/{locking-mechanism,logo-placement} via *SceneHandlers), so they are
// no longer mounted here.
// THICKNESS and VALVE scene handlers (OutwardThicknessHandler /
// ValvePlacementHandler) are now mounted by their migrated feature steps
// (features/{thickness,valve} via *SceneHandlers), so they are no longer
// switched on here.

// Main steps that show the 3D scene and left toolbar; Measure/Circumference and
// the circumference-lines table are available on these steps
const MAIN_STEPS_WITH_MEASURE_TOOLS = [
    MAIN_PROCESS_STEPS.RECTIFICATION,
    MAIN_PROCESS_STEPS.ELONGATION,
    MAIN_PROCESS_STEPS.TRIMLINE,
    MAIN_PROCESS_STEPS.THICKNESS,
    MAIN_PROCESS_STEPS.ML_REDUCTION,
    MAIN_PROCESS_STEPS.FLARES,
    MAIN_PROCESS_STEPS.LOCKING_MECHANISM,
    MAIN_PROCESS_STEPS.VALVE_PATTERN,
    MAIN_PROCESS_STEPS.VALVE,
    MAIN_PROCESS_STEPS.LOGO_PLACEMENT,
    // MAIN_PROCESS_STEPS.PADS,
];

const STEP_BY_PATH = Object.fromEntries(
    Object.entries(PATHS).map(([step, path]) => [path, step])
);

export function ToolHandler()
{
    const location = useLocation();
    const storeCurrentStep = useWorkflowStore((state) => state.currentStep);
    const routeStep = STEP_BY_PATH[location.pathname];
    const currentStep = routeStep || storeCurrentStep;

    if (routeStep && routeStep !== storeCurrentStep) {
        console.log('[ToolHandlerPerf] route/store step mismatch; using route step', {
            pathname: location.pathname,
            routeStep,
            storeCurrentStep,
        });
    }

    const getTool = () =>
    {
        switch(currentStep)
        {
            // PREPARING_SCAN + AXES_ALIGNMENT + RECTIFICATION + ELONGATION +
            // TRIMLINE + ML_REDUCTION + FLARES + THICKNESS + VALVE migrated: their
            // scene handlers are mounted by the step (via *SceneHandlers in
            // features/*).
            default:
                return null;
        }
    }

    const isMainStepWithMeasureTools = MAIN_STEPS_WITH_MEASURE_TOOLS.includes(currentStep);

    return (
        <div className="absolute left-0 top-0 w-full h-full -z-10">
            {getTool()}
            {isMainStepWithMeasureTools && (
                <>
                    <MeasureHandler />
                    <CircumferenceHandler />
                    <CircumferenceLinesHandler />
                </>
            )}
        </div>
    );
}